import { render, staticRenderFns } from "./surprisersWrapper.vue?vue&type=template&id=7e530b08&"
import script from "./surprisersWrapper.vue?vue&type=script&lang=js&"
export * from "./surprisersWrapper.vue?vue&type=script&lang=js&"
import style0 from "./surprisersWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports